export const formatCount = (n) => {
    if (n >= 1_000_000) return `${+( n / 1_000_000).toFixed(1)}M`
    if (n >= 10_000)    return `${+(n / 1_000).toFixed(1)}k`
    return n
}
